import React, { ReactNode, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { HashRouter } from "react-router-dom";
import { StoreProvider } from "easy-peasy";

import store from "store/store";
import Theme from "theme/theme";

type Props = {
  children: ReactNode;
};

const Providers = ({ children }: Props) => {
  const methods = useForm({ shouldFocusError: true, mode: "all" });
  // Only the phone/desktop switch matters here. Keeping the raw width in state
  // re-rendered the whole app on every resize event, and mobile browsers fire
  // those while scrolling as the address bar shows and hides.
  const [isMobile, setIsMobile] = useState<boolean>(
    () => window.innerWidth <= 768
  );

  useEffect(() => {
    const handleWindowSizeChange = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    // v7_startTransition: a step change that suspends while its chunk loads
    // keeps the current step on screen instead of swapping in the small
    // RouteFallback spinner. That swap collapsed the form, pulled the footer up
    // and then pushed it back once the step rendered — ~0.8 CLS per slow step
    // change on a phone, counted because it landed >500ms after the tap.
    <HashRouter future={{ v7_startTransition: true }}>
      <StoreProvider store={store}>
        <Theme isMobile={isMobile}>
          <FormProvider {...methods}>{children}</FormProvider>
        </Theme>
      </StoreProvider>
    </HashRouter>
  );
};

export default Providers;
